/* eslint-disable */
import Vue from 'vue'
import msgboxVue from './index.vue'
import store from '@/store'

var defaults = {
  title: '',
  message: '',
  showClose: true,
  modal: true,
  restStyle: {},
  callback: null,
  closeCallback: null,
  buttonCallback: null, // 按钮点击回调
  pageType: 'mine_popup_role3', // 页面类型配置
}

var merge = function (target) {
  for (let i = 1, j = arguments.length; i < j; i++) {
    let source = arguments[i] || {}
    for (let prop in source) {
      if (source.hasOwnProperty(prop)) {
        let value = source[prop]
        if (value !== undefined) {
          target[prop] = value
        }
      }
    }
  }
  return target
}

var MessageBoxConstructor = Vue.extend(msgboxVue) // 创造一个构造器，为了创建可复用组件
var currentMsg, instance
var msgQueue = []

const defaultCallback = action => {
  if (currentMsg) {
    let callback = currentMsg.callback
    if (typeof callback === 'function') {
      callback(action)
    }
    if (currentMsg.resolve) {
      if (action === 'confirm') {
        currentMsg.resolve(action)
      } else if (action === 'cancel' && currentMsg.reject) {
        currentMsg.reject(action)
      }
    }
  }
}

var initInstance = function (options) {
  instance = new MessageBoxConstructor({
    el: document.createElement('div')
  })
  instance.callback = defaultCallback
  merge(instance, options)
}

var showNextMsg = function (options) {
  if (!instance) {
    initInstance(options)
  }
  
  if (msgQueue.length > 0) {
    currentMsg = msgQueue.shift()
    let options = currentMsg.options
    for (let prop in options) {
      if (options.hasOwnProperty(prop)) {
        instance[prop] = options[prop]
      }
    }
    
    if (options.callback === undefined) {
      instance.callback = defaultCallback
    }
    
    document.body.appendChild(instance.$el)
    Vue.nextTick(() => {
      instance.show(options)
    })
  }
}

var MessageBox = function (options, callback) {
  if (typeof options === 'string') {
    options = {
      message: options
    }
    if (arguments[1]) {
      options.title = arguments[1]
    }
    if (arguments[2]) {
      options = merge(options, arguments[2])
    }
  } else if (options.callback && !callback) {
    callback = options.callback
  }
  
  if (typeof Promise !== 'undefined') {
    return new Promise((resolve, reject) => {
      msgQueue.push({
        options: merge({}, defaults, MessageBox.defaults || {}, options),
        callback: callback,
        resolve: resolve,
        reject: reject
      })
      
      showNextMsg()
    })
  } else {
    msgQueue.push({
      options: merge({}, defaults, MessageBox.defaults || {}, options),
      callback: callback
    })
    
    showNextMsg()
  }
}

MessageBox.setDefaults = function (options = defaults) {
  MessageBox.defaults = options
}

MessageBox.alert = function (message, title, options) {
  if (typeof title === 'object') {
    options = title
    title = ''
  }
  return MessageBox(merge({
    title: title,
    message: message,
    showClose: true,
  }, options))
}

MessageBox.show = function (options) {
  return MessageBox(options || {})
}

MessageBox.close = function (reset) {
  if (instance) {
    instance.doClose()
    if (reset) {
      msgQueue = []
      currentMsg = null
    }
  }
}

// 提供install方法
MessageBox.install = function (Vue, options) {
  Vue.prototype.$RaiseBoxRole3 = MessageBox
  return MessageBox
}

export default MessageBox
export {
  MessageBox
}